// extracted by mini-css-extract-plugin
module.exports = {"title":"highlight-reel_title__Ju0mG","container":"highlight-reel_container__y85Cz"};